import Swiper from 'swiper';
import 'swiper/swiper.scss';

export default new (class {
  constructor() {
    this.data = {};
    this.selectors = {
      carousel: '.c-horizontal-products-carousel',
    };
    this.settings = {
      swiper: {
        centeredSlides: true,
        grabCursor: true,
        loop: true,
        spaceBetween: 8,
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        loopFillGroupWithBlank: false,
        roundLengths: true,
        setWrapperSize: true,
        loopedSlides: 3,
        loopAdditionalSlides: 5,
        initialSlide: 1,
        breakpoints: {
          768: {
            loopAdditionalSlides: 10,
            spaceBetween: 24,
          },
        },
        on: {
          init: (swiper) => {
            swiper.setProgress(0.5);
          },
        },
      },
    };
  }

  init() {
    this.getDOM();
    this.initSwiper();
    window.addEventListener('resize', () => {
      this.swiper.destroy();
      this.initSwiper();
    });
  }

  getDOM() {
    this.DOM = {
      carousel: document.querySelector(this.selectors.carousel),
    };
  }

  initSwiper() {
    this.swiper = new Swiper(this.DOM.carousel, this.settings.swiper);
  }
})();
